export function updateURLWithChangedFilters(newFilters) {
  const queryParams = getQueryParamsFromFilters(newFilters);
  window.history.pushState(null, "", `?${queryParams}`);
}

export function getQueryParamsFromFilters(filters) {
  const params = [];

  Object.entries(filters).forEach(([key, value]) => {
    if (
      value === undefined ||
      value === null ||
      value === "" ||
      value === false || 
      (Array.isArray(value) && value.length === 0) ||
      (typeof value === "object" && Object.keys(value).length === 0)
    ) {
      return;
    }

    if (Array.isArray(value)) {
      // Convert array to comma-separated string (no brackets)
      if (value.length > 0) {
        params.push(`${encodeURIComponent(key)}=${encodeURIComponent(value.join(","))}`);
      }
    }
    else if (typeof value === "object") {
      if (key === "options") {
        Object.entries(value).forEach(([optionKey, optionValues]) => {
          if (Array.isArray(optionValues) && optionValues.length > 0) {
            params.push(`options[${optionKey}]=${encodeURIComponent(optionValues.join(","))}`);
          }
        });
      }
    }
    else if (key === "with_locks" && value === true) {
      // Creates "with-locks" WITHOUT any equals sign
      params.push("with-locks");
    } 
    else if (key === "instant_booking" && value === true) {
      params.push(`instant_booking=true`);
    }
    else {
      params.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
    }
  });

  return params.join('&');
}

export function getFiltersFromQueryParams(queryString) {
  // Handle empty or non-string input
  if (!queryString || typeof queryString !== 'string') {
    return {};
  }
  
  // Remove leading '?' if present
  let cleanQueryString = queryString.startsWith('?') ? queryString.substring(1) : queryString;
  
  // Handle empty string after removing '?'
  if (!cleanQueryString) {
    return {};
  }
  
  const newFilters = {};
  
  // Manually parse the query string to preserve all parameters
  const urlParams = cleanQueryString.split('&');
  
  urlParams.forEach(param => {
    if (!param) return;
    
    // Handle parameters with and without values
    let key, value;
    const equalIndex = param.indexOf('=');
    
    if (equalIndex === -1) {
      // Parameter without value (like 'with-locks')
      key = decodeURIComponent(param);
      value = '';
    } else {
      // Parameter with value
      key = decodeURIComponent(param.substring(0, equalIndex));
      value = decodeURIComponent(param.substring(equalIndex + 1));
    }
    
    // Handle with-locks flag (no value)
    if (key === 'with-locks' && value === '') {
      newFilters.with_locks = true;
    }
    // Handle instant_booking
    else if (key === 'instant_booking') {
      newFilters.instant_booking = value === 'true';
    }
    // Handle usages (comma-separated values)
    else if (key === 'usages' && value) {
      newFilters.usages = value.includes(',') ? value.split(',') : [value];
    }
    // Handle lat/lng as numbers
    else if (key === 'lat' || key === 'lng' || key === 'lat_p1' || key === 'lat_p2' || key === 'lng_p1' || key === 'lng_p2') {
      newFilters[key] = parseFloat(value);
    }
    // Handle options object
    else if (key.startsWith('options[')) {
      const optionKey = key.replace('options[', '').replace(']', '');
      if (!newFilters.options) {
        newFilters.options = {};
      }
      if (value && value.includes(',')) {
        newFilters.options[optionKey] = value.split(',');
      } else if (value) {
        newFilters.options[optionKey] = [value];
      }
    }
    // Handle all other parameters (including style, capacity, page, perPage, etc.)
    else if (value !== '' || value !== undefined) {
      // If it's a comma-separated value and not a UUID pattern, split it
      if (value && value.includes(',') && !value.match(/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i)) {
        newFilters[key] = value.split(',');
      } else if (value === 'true' || value === 'false') {
        newFilters[key] = value === 'true';
      } else {
        newFilters[key] = value;
      }
    }
  });
  
  return newFilters;
}